import { useProfile } from '@/api/profile'
import { useCompanyPhoneNumbers } from '@/api/company'
import { useAIAgents } from '@/api/aiAgents'
import { useTeamMembers } from '@/api/agents'
import { useSubscriptionStatus } from '@/api/subscription'

/**
 * Les pas obligatoires de « Commencer » : une seule définition pour la page
 * Commencer et le téléphone (l'accueil et l'entrée du menu partent quand ils
 * sont faits). L'agenda est facultatif, il n'en fait pas partie.
 * `actif` à false ne charge ni les numéros ni les agents IA.
 */
export function useMiseEnRoute(actif = true) {
  const { data: profile } = useProfile()
  const companyId = actif ? profile?.company : undefined
  const numeros = useCompanyPhoneNumbers(companyId)
  const agents = useAIAgents(companyId)
  const membres = useTeamMembers()

  const pas = {
    numero: (numeros.data?.phone_numbers?.length ?? 0) > 0,
    agent: (agents.data?.length ?? 0) > 0,
    equipe: (membres.data?.length ?? 0) > 1,
    app: !!profile?.mobile_app_installed,
  }
  // Tant que tout n'est pas chargé, on ne tranche pas : pas d'accueil qui apparaît puis disparaît.
  const pret = !!profile && numeros.isSuccess && agents.isSuccess && membres.isSuccess
  return { pas, pret, finie: pret && Object.values(pas).every(Boolean) }
}

/**
 * Manager pendant l'essai : c'est lui qui finit la mise en route et choisit
 * le plan. L'agent n'en voit rien.
 */
function useManagerEnEssai(): boolean {
  const { data: profile } = useProfile()
  const { data: abonnement } = useSubscriptionStatus()
  return profile?.role === 'MANAGER' && abonnement?.subscription?.status === 'trialing'
}

/**
 * Téléphone : le manager en essai garde « Commencer » et l'accueil tant que
 * la mise en route n'est pas finie. undefined : pas encore tranché (chargement).
 */
export function useMiseEnRouteAFinir(): boolean | undefined {
  const enEssai = useManagerEnEssai()
  const { pret, finie } = useMiseEnRoute(enEssai)
  if (!enEssai) return false
  return pret ? !finie : undefined
}
